// extracted by mini-css-extract-plugin
export var heroTitle = "q-and-a-module--hero-title--1ETIS";
export var detailsRichtext = "q-and-a-module--details-richtext--3jkA9";